// extracted by mini-css-extract-plugin
export var subtitle = "_ch-2";
export var title = "_ch-0";
export var titleNoWrap = "_ch-1";